import cn from 'classnames';
import { FC, MouseEvent, ReactNode } from 'react';
import { Link } from 'react-router';

import styles from './NavList.module.scss';

type NavItemProps = {
  className?: string;
  active?: boolean;
  nested?: boolean;
  disabled?: boolean;
  href?: string;
  to?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: any;
  prefix?: ReactNode;
  suffix?: ReactNode;
  children: ReactNode;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

export const NavItem: FC<NavItemProps> = (props) => {
  const {
    className,
    active,
    nested,
    disabled,
    href,
    to,
    state,
    prefix,
    suffix,
    children,
    onClick,
  } = props;

  const itemClassName = cn(
    styles.item,
    nested && styles.itemNested,
    active && styles.itemActive,
    className,
  );

  const content = (
    <>
      {prefix !== undefined && prefix !== null && (
        <span className={styles.prefix}>{prefix}</span>
      )}
      <span className={styles.label}>{children}</span>
      {suffix !== undefined && suffix !== null && (
        <span className={styles.suffix}>{suffix}</span>
      )}
    </>
  );

  if (to) {
    return (
      <Link
        className={itemClassName}
        to={to}
        state={state}
        onClick={onClick}
        role="listitem"
      >
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        className={itemClassName}
        href={href}
        onClick={onClick}
        role="listitem"
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={itemClassName}
      onClick={onClick}
      disabled={disabled}
      role="listitem"
    >
      {content}
    </button>
  );
};

type NavCountProps = {
  className?: string;
  children: ReactNode;
};

export const NavCount: FC<NavCountProps> = (props) => {
  const { className, children } = props;

  return <span className={cn(styles.count, className)}>{children}</span>;
};
